module.exports = __webpack_public_path__ + "img/sign-name2.417d5e5c.png";